// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pointer[data-v-078ae899]{cursor:pointer}@media(max-width: xs){.stars[data-v-078ae899]{gap:0}}@media(max-width: xs){.stars>img[data-v-078ae899]{width:45px;height:35px;object-fit:contain}}", ""]);
// Exports
module.exports = exports;
